module.exports = __webpack_public_path__ + "media/promo/velle/images/test-0bfca45bf5e09d60d018492ba4c0181d.png";